var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("q-table", {
          staticClass: "full-width",
          attrs: {
            selection: "multiple",
            data: _vm.affiliateOverrideList,
            columns: _vm.columns,
            loading: _vm.loading,
            selected: _vm.selectedOverrides,
            pagination: _vm.pagination,
            "row-key": "ORDER_TYPE_OVERRIDE_ID"
          },
          on: {
            "update:selected": function($event) {
              _vm.selectedOverrides = $event
            },
            "update:pagination": function($event) {
              _vm.pagination = $event
            },
            request: _vm.fetchOrderTypeOverrides
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function(props) {
                return _c(
                  "q-tr",
                  {},
                  [
                    _c(
                      "q-th",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          staticClass: "q-mr-md",
                          attrs: {
                            value: null,
                            "indeterminate-icon": "unfold_more"
                          }
                        }),
                        props.multipleSelect
                          ? _c("q-checkbox", {
                              attrs: { "indeterminate-value": "some" },
                              model: {
                                value: props.selected,
                                callback: function($$v) {
                                  _vm.$set(props, "selected", $$v)
                                },
                                expression: "props.selected"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(props.cols, function(col) {
                      return _c(
                        "q-th",
                        { key: col.name, attrs: { props: props } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(col.label) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }
            },
            {
              key: "body",
              fn: function(props) {
                return [
                  _c(
                    "q-tr",
                    { attrs: { props: props } },
                    [
                      _c(
                        "q-td",
                        { attrs: { "auto-width": "" } },
                        [
                          _c("q-checkbox", {
                            staticClass: "q-mr-md",
                            attrs: {
                              color: "primary",
                              "checked-icon": "expand_less",
                              "unchecked-icon": "expand_more"
                            },
                            model: {
                              value: props.expand,
                              callback: function($$v) {
                                _vm.$set(props, "expand", $$v)
                              },
                              expression: "props.expand"
                            }
                          }),
                          _c("q-checkbox", {
                            attrs: { color: "primary" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedAffiliateOverrides(
                                  _vm.selectedOverrides
                                )
                              }
                            },
                            model: {
                              value: props.selected,
                              callback: function($$v) {
                                _vm.$set(props, "selected", $$v)
                              },
                              expression: "props.selected"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-td",
                        { key: "AFFILIATE_CODE", attrs: { props: props } },
                        [_vm._v(_vm._s(props.row.AFFILIATE.AFFILIATE_CODE))]
                      ),
                      _c(
                        "q-td",
                        { key: "AFFILIATE_NAME", attrs: { props: props } },
                        [_vm._v(_vm._s(props.row.AFFILIATE.AFFILIATE_NAME))]
                      ),
                      _c(
                        "q-td",
                        { key: "USER_EMAIL", attrs: { props: props } },
                        [_vm._v(_vm._s(props.row.USER.USER_EMAIL))]
                      ),
                      _c("q-td", { key: "PRICE", attrs: { props: props } }, [
                        _vm._v(_vm._s(props.row.PRICE))
                      ]),
                      _c(
                        "q-td",
                        { key: "MIN_AMOUNT", attrs: { props: props } },
                        [_vm._v(_vm._s(props.row.MIN_AMOUNT))]
                      ),
                      _c(
                        "q-td",
                        { key: "MAX_AMOUNT", attrs: { props: props } },
                        [_vm._v(_vm._s(props.row.MAX_AMOUNT))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: props.expand,
                          expression: "props.expand"
                        }
                      ],
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-td",
                        { attrs: { colspan: "100%" } },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "q-field",
                                { staticClass: "q-pa-md col-4" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "stack-label": "Price Override",
                                      type: "number",
                                      prefix: "$"
                                    },
                                    on: {
                                      input: function($event) {
                                        props.selected = false
                                      }
                                    },
                                    model: {
                                      value: props.row.PRICE,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "PRICE", $$v)
                                      },
                                      expression: "props.row.PRICE"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-field",
                                { staticClass: "q-pa-md col-4" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "stack-label": "Minimum Amount Override",
                                      type: "number"
                                    },
                                    on: {
                                      input: function($event) {
                                        props.selected = false
                                      }
                                    },
                                    model: {
                                      value: props.row.MIN_AMOUNT,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "MIN_AMOUNT", $$v)
                                      },
                                      expression: "props.row.MIN_AMOUNT"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-field",
                                { staticClass: "q-pa-md col-4" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "stack-label": "Maximum Amount Override",
                                      type: "number"
                                    },
                                    on: {
                                      input: function($event) {
                                        props.selected = false
                                      }
                                    },
                                    model: {
                                      value: props.row.MAX_AMOUNT,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "MAX_AMOUNT", $$v)
                                      },
                                      expression: "props.row.MAX_AMOUNT"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "h6",
                            [
                              _vm._v(" Shipping Methods\n                "),
                              _c(
                                "q-btn",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        props.row.SHIPPING_METHODS.length <
                                        _vm.shippingTypeOptions.length,
                                      expression:
                                        "props.row.SHIPPING_METHODS.length < shippingTypeOptions.length"
                                    }
                                  ],
                                  attrs: { icon: "add", id: "addShippingType" },
                                  on: {
                                    click: function($event) {
                                      _vm.addShippingMethod(
                                        props.row.overrideIndex
                                      )
                                      props.selected = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "center right",
                                        self: "center left",
                                        offset: [10, 10]
                                      }
                                    },
                                    [_vm._v("Add a Shipping Type")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        props.row.SHIPPING_METHODS.length === 0,
                                      expression:
                                        "props.row.SHIPPING_METHODS.length === 0"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "label bg-primary" },
                                    [_vm._v("Please Add a Shipping Type!")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._l(props.row.SHIPPING_METHODS, function(
                            shippingMethod,
                            shippingMethodIndex
                          ) {
                            return _c(
                              "div",
                              { key: shippingMethodIndex, staticClass: "row" },
                              [
                                _c(
                                  "q-field",
                                  { staticClass: "q-pa-md col-3" },
                                  [
                                    _c("q-select", {
                                      attrs: {
                                        "float-label": "Shipping Type",
                                        options: _vm.remainingShippingTypeOptions(
                                          props.row.SHIPPING_METHODS,
                                          shippingMethod.LK_SHIPPING_TYPE_ID
                                        )
                                      },
                                      on: {
                                        input: function($event) {
                                          props.selected = false
                                        }
                                      },
                                      model: {
                                        value:
                                          shippingMethod.LK_SHIPPING_TYPE_ID,
                                        callback: function($$v) {
                                          _vm.$set(
                                            shippingMethod,
                                            "LK_SHIPPING_TYPE_ID",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "shippingMethod.LK_SHIPPING_TYPE_ID"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  { staticClass: "q-pa-md col-2" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "number",
                                        "stack-label": "Price",
                                        prefix: "$"
                                      },
                                      on: {
                                        input: function($event) {
                                          props.selected = false
                                        }
                                      },
                                      model: {
                                        value: shippingMethod.PRICE,
                                        callback: function($$v) {
                                          _vm.$set(shippingMethod, "PRICE", $$v)
                                        },
                                        expression: "shippingMethod.PRICE"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  { staticClass: "q-pa-md col-2" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "number",
                                        "stack-label": "Item Limit",
                                        prefix: "x"
                                      },
                                      on: {
                                        input: function($event) {
                                          props.selected = false
                                        }
                                      },
                                      model: {
                                        value: shippingMethod.ITEM_LIMIT,
                                        callback: function($$v) {
                                          _vm.$set(
                                            shippingMethod,
                                            "ITEM_LIMIT",
                                            $$v
                                          )
                                        },
                                        expression: "shippingMethod.ITEM_LIMIT"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  { staticClass: "q-ma-lg col-2" },
                                  [
                                    _c("q-toggle", {
                                      attrs: { label: "Default" },
                                      on: {
                                        input: function($event) {
                                          _vm.forceSingleDefault(
                                            shippingMethodIndex,
                                            props.row.SHIPPING_METHODS
                                          )
                                        }
                                      },
                                      model: {
                                        value: shippingMethod.IS_DEFAULT,
                                        callback: function($$v) {
                                          _vm.$set(
                                            shippingMethod,
                                            "IS_DEFAULT",
                                            $$v
                                          )
                                        },
                                        expression: "shippingMethod.IS_DEFAULT"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("q-btn", {
                                  staticClass: "float-right",
                                  attrs: { size: "md", icon: "delete" },
                                  on: {
                                    click: function($event) {
                                      _vm.removeShippingMethod(
                                        props.row.overrideIndex,
                                        shippingMethodIndex
                                      )
                                      props.selected = false
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }